import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  button: {
    position: 'absolute',
    bottom: 16,
    left: 19,
    zIndex: 50,
    minHeight: 'auto',
    padding: 4,
    borderWidth: 2,
    borderColor: 'transparent',
  },
  buttonInner: {
    flexDirection: 'row',
    gap: 6,
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
  icon: {
    width: 16,
    height: 16,
  },
  text: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 15,
    color: neutrals.neutralGrays.ash,
  },
  textHover: {
    color: brand.main.variations['darkerWater-1'],
  },
});
